import { isTutorialApp, filterAppsForLicense } from './filters'

export const getStaticAppsList = (
  allApps,
  allFeedback,
  shouldFilterOutMaintenanceApps = true
) => {
  return filterAppsForLicense(
    allApps.nodes,
    undefined,
    undefined,
    undefined,
    shouldFilterOutMaintenanceApps
  ).reduce((acc, app) => {
    if (isTutorialApp(app) || app.hidden) {
      return acc
    }

    const feedback = allFeedback?.nodes?.find(
      ({ product }) => product === app.id
    )
    app.rating = feedback ? { rate: feedback.rate } : null

    acc.push(app)

    return acc
  }, [])
}
